import axios from 'axios'
// import qs from 'qs'
import {serverIpAddress, httpTimeout, weChatAppId} from './systemConfig'
import {AesUtil} from './AESUtils'
import {cookiesModule} from './cookiesModule'
import {sessionSto} from './sessionStorageManage'
import {localStorage} from './localStorageModule.js'
import { Toast } from 'vant'
import router from '../router'


// 浏览器类型 weChat: 微信公众号； 
export function browserType(){
  if(navigator.userAgent.match(/(Robot|Spider)/i)){
    router.push({name: 'notFount'})
  }
  let us = navigator.userAgent.toLocaleLowerCase()
  if(/micromessenger/i.test(us)){
    return "weChat"
  }else{
    return "other"
  }
}

export var appID = weChatAppId // "wx04077839db7fcb48" // "wx17dfd3efb39c2d50"
export var userOpenid = ""   // 用户ID（需要授权

function getHeadersData(method, url){
  let tokenInfo = localStorage.$selectLocalStorage('tokenInfo')
  let headerToken = {}
  
  let contentType = ""
  if(method == "POST" || method == "PUT"){
    contentType = 'multipart/form-data;charset=utf-8'
  }
  
  if(method == "GET" || method == "DELETE"){
    contentType = 'application/json;charset=utf-8'
  }

  if(tokenInfo){
    headerToken = {
      Authorization: tokenInfo,
      "Content-Type": contentType
    }
  }
  
  headerToken.language =
    sessionStorage.getItem("langType") === "en" ? "English" : "chinese";
  return headerToken
}

// 获取用户信息
export async function getWeChatInfo(code) {
  var userInfo = cookiesModule.$getCookieByKey2("userInfo")
  console.log("userInfo", userInfo)
  if(userInfo){
    userInfo = AesUtil.getAxiosHeadJSONstr(userInfo)
    userInfo = JSON.parse(userInfo)
    return userInfo
  }
  if(!code){
    return
  }
  var redirectUrl = window.location.href.indexOf("?") > 0?window.location.href.split("?")[0]:window.location.href
  const data = {
    code: code,
    state: encodeURIComponent(redirectUrl)
  }
  // 获取请求token
  let tokenInfo = await apiAxios("GET", "/wechat/getTokenInfo", data, false)
  if(tokenInfo.code == 200){
    let token = tokenInfo.msg
    localStorage.$insertLocalStorage('tokenInfo', token)
    localStorage.$insertLocalStorage('outTime', new Date().getTime())
  }
  // 获取用户信息
  let userGetHttp = await apiAxios("GET", "/getUserInfo")
  userInfo = userGetHttp.data
  if(userInfo){
    cookiesModule.$setNewCookie("userInfo", userInfo)
    sessionSto.$insertSessionStorage("userInfo", userInfo)
  }
  try {
    userInfo = JSON.parse(userInfo)
  } catch (error) {
    
  }
  return userInfo
}

// var baseURL = process.env.NODE_ENV == 'development' ? '/apis' : serverIpAddress
var baseURL = serverIpAddress

function apiAxios (method, url, params, needAes) {
  let formData = new FormData()
  const params_aes = AesUtil.getAxiosJSONstr(params)
  let params_use = undefined
  if((method == 'POST' || method == 'PUT') && params){
    let text = AesUtil.getAxiosJSONstr(params).text
    formData.append('text', text)
  }else{
    if(needAes){
      params_use = params_aes
    }else{
      params_use = params
    }
    console.log(params_use)
  }
  let httpDefault = {
    method: method,
    baseURL: baseURL, // "/apis", //"http://60.168.145.116:8754/", // "http://192.168.11.201:8080"
    url: url,
    headers: getHeadersData(method, url),
    params: method === 'GET' || method === 'DELETE' ? params_use : null,
    data: method === 'POST' || method === 'PUT' ? formData : null,
    // 访问超时时间
    timeout: httpTimeout
  }

  // 注意**Promise**使用(Promise首字母大写)
  return new Promise(function(resolve, reject){
    axios(httpDefault).then(function(res){
      console.log(url, res)
      if(res.code == 200){
        let data = res.data
        // 如果data是JSON字符串则转为对象
        try {
          res.data = JSON.parse(AesUtil.getAxiosHeadJSONstr(res.data))
        } catch (error) {
          res.data = data
          console.error(error)
        }
      }
      resolve(res)
    }).catch((response) => {
      errorState(response)
      reject(response)
    })
  })
}
// 请求返回失败提示函数---------------------------------------------------------------------------
function errorState (response) {
  if(response.code = 0){
    console.error("请求成功,但是处理请求结果存在问题！")
  }else{
    console.error("访问服务器出现异常！")
  }
}
var weChatIsConfig = false
// wxConfig初始化
export function wxSDKready() {
  // var data = {
    // url参数必须使用当前路由#之前的路径， 不能使用encodeURIComponent转义
    /**
     * 微信SDK文档 附录5 第6条：确保你获取用来签名的url是动态获取的，动态页面可参见实例代码中php的实现方式。
     * 如果是html的静态页面在前端通过ajax将url传到后台签名，前端需要用js获取当前页面除去'#'hash部分的链接
     * （可用location.href.split('#')[0]获取,而且需要encodeURIComponent），因为页面一旦分享，微信客户端
     * 会在你的链接末尾加入其它参数，如果不是动态获取当前链接，将导致分享后的页面签名失败。
     * 
     * 
     * 特别说明：该文档内容是错误的，不能使用encodeURIComponent转义
     */
    // text: location.href.split("?")[0]
  // }
  var data = location.href.split("#")[0]
  apiAxios("GET", "/wechat/getSignature", data, true).then((res)=>{
    let resData = res.data
    wx.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出
      appId: resData.appId, // 必填，公众号的唯一标识
      timestamp: resData.timestamp + "", // 必填，生成签名的时间戳
      nonceStr: resData.nonceStr + "", // 必填，生成签名的随机串
      signature: resData.signature, // 必填，签名jsApiList
      jsApiList: ['chooseImage', 'scanQRCode', 'chooseWXPay'], // 必填，需要使用的JS接口列表
      success(){
        weChatIsConfig = true
      }
    })
  })
}

// 微信用户选取图片
export function chooseImage(fun, num){
  if(browserType() != "weChat"){
    return
  }
  if(weChatIsConfig){
    wx.chooseImage({
      count: num, // 默认9
      sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
      sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
      success: fun
    })
  }else{
    wxSDKready()
    wx.ready(function(){
      wx.chooseImage({
        count: num, // 默认9
        sizeType: ['original', 'compressed'],
        sourceType: ['album', 'camera'],
        success: fun
      })
    })
  }
}

// 获取图片文件实例 （base64）
export async function getLocalImgData(localId, fun){
  if(weChatIsConfig){
    wx.getLocalImgData({
      localId: localId,
      success: fun
    })
  }else{
    wx.ready(function(){
      wx.getLocalImgData({
        localId: localId,
        success: fun
      })
    })
  }
}

// 微信用户上传图片
export async function uploadImage(localId, fun){
  if(browserType() != "weChat"){
    return
  }
  if(weChatIsConfig){
    wx.uploadImage({
      localId: localId, // 需要上传的图片的本地ID，由chooseImage接口获得
      isShowProgressTips: 1, // 默认为1，显示进度提示
      success: fun
    })
  }else{
    wx.ready(function(){
      wx.uploadImage({
        localId: localId, // 需要上传的图片的本地ID，由chooseImage接口获得
        isShowProgressTips: 1, // 默认为1，显示进度提示
        success: fun
      })
    })
  }
}

// 微信扫一扫
export function getQrScanCode(fun) {
  let tokenInfo = localStorage.$selectLocalStorage('tokenInfo')
  if(browserType() != "weChat" || !tokenInfo){
    return
  }
  if(weChatIsConfig){
    wx.scanQRCode({
      needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
      scanType: ["qrCode","barCode"], // 可以指定扫二维码还是一维码，默认二者都有
      success: fun,
      fail: () => {
        weChatIsConfig = false
        wxSDKready()
        wx.ready(function(){
          wx.scanQRCode({
            needResult: 1,
            scanType: ["qrCode","barCode"],
            success: fun
          })
        })
      }
    })
  }else{
    wx.ready(function(){
      wx.scanQRCode({
        needResult: 1,
        scanType: ["qrCode","barCode"],
        success: fun
      })
    })
  }
}

// 微信公众号支付接口
export function weChatJSApiPay(outTradeNo, totalFee, body) {
  const userStr = cookiesModule.$getCookieByKey2("userInfo")
  let user = null
  try {
    user = JSON.parse(userStr)
  } catch (error) {
    console.error(error)
  }
  
  console.log("userStr", userStr)
  console.log("user", user)

  var data = {
    outTradeNo: outTradeNo,
    totalFee: totalFee * 100 + '',
    body: body,
    openid: user ? user.openid : "",
    url: location.href.split("?")[0]
  }
  console.log(data)

  apiAxios("POST", "/wxPay/JSAPIPay", data).then((res)=>{
    // Toast('开始请求微信——2')
    let resData = res.data
    if(res.code == 200){
      console.log("支付", resData)
      WeixinJSBridge.invoke(
        'getBrandWCPayRequest', {
          "appId": 'wxf357e7683b7e3c4b',     //公众号名称，由商户传入
          "timeStamp": resData.timeStamp,
          "nonceStr": resData.nonceStr, //随机串
          "package": resData.package,
          "signType": resData.signType,         //微信签名方式
          "paySign": resData.paySign, //微信签名
          "totalFee": totalFee * 100
        },
        function(res){
          setTimeout(() => {
            router.push({name: 'mobile_myOrders'})
          }, 1500)
        }
      )

      // wx.chooseWXPay({
      //   "appId": resData.appId,     //公众号名称，由商户传入
      //   "timestamp": resData.timeStamp * 1000,
      //   "nonceStr": resData.nonceStr, //随机串
      //   "package": resData.package,
      //   "signType": resData.signType,         //微信签名方式
      //   "paySign": resData.paySign, //微信签名
      //   "totalFee": totalFee * 100,
      //   "fail": function(res){
      //     setTimeout(() => {
      //       router.push({name: 'mobile_myOrders'})
      //     }, 1500)
      //   }
      // })



      weChatIsConfig = true
    }else{
      Toast({
        position: 'bottom',
        message: res.msg
      })
    }
  }).catch(cat => {
    Toast({
      position: 'bottom',
      message: '访问服务器出错了'
    })
  })
}

export const weChat = {
  $browserType: () => browserType()
}


// WEBPACK FOOTER //
// ./src/util/weChat.js